/**
 * Domains read from the build-time environment.
 *
 * Each value has a safe default so the app runs correctly with no environment
 * configuration at all — an unset variable never breaks a build or a page.
 */

/**
 * Base domain of generated apps: a project's custom domain is
 * <name>.<GENERATED_APP_BASE_DOMAIN>. It must match the backend's
 * GENERATED_APP_BASE_DOMAIN, which builds the real address; the frontend only
 * shows it. Defaults to production's, so an environment without
 * VITE_GENERATED_APP_BASE_DOMAIN shows what it always did.
 */
export const GENERATED_APP_BASE_DOMAIN =
  import.meta.env.VITE_GENERATED_APP_BASE_DOMAIN || 'veyloapp.ai';
